import { render, staticRenderFns } from "./UpdateRootUser.vue?vue&type=template&id=2b151fc4&scoped=true"
import script from "./UpdateRootUser.vue?vue&type=script&lang=js"
export * from "./UpdateRootUser.vue?vue&type=script&lang=js"
import style0 from "./UpdateRootUser.vue?vue&type=style&index=0&id=2b151fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b151fc4",
  null
  
)

export default component.exports